import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }
const _hoisted_2 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}
const _hoisted_3 = ["src"]

import Api from '@/services/api';
    import { Car, Event, Segment, TravelCompany, Route } from '@/services/types';
    import { ElButton, ElDialog, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInput, ElFormItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import PersonalTable from '@/components/PersonalTable.vue';
    import CreateCar from '@/components/modals/creates/CreateCar.vue';
    import CreateTravelPrice from '@/components/modals/creates/CreateTravelPrice.vue';
    import CreateTravel from '@/components/modals/creates/CreateTravel.vue';

    type TripSegment = Segment & {
        pivot: {
            price: number
            created_at?: string | Date
        }
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

    const route = useRoute()
    const id = route.params.id

    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)

    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const apiImage = ref<string>()
    const showModal1 = ref<boolean>(false)
    const showModal2 = ref<boolean>(false)
    const showTravels = ref<boolean>(false)
    const cars = ref<Array<Car>>([])
    const segments = ref<Array<TripSegment>>([])
    const routes = ref<Array<Route>>([])
    
    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: {lat: 0, long: 0, name: ''},
        id: 0,
        user: undefined,
        segments: [],
        phone: null,
        password: null
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=travel_companies/${image}`

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            company.image = URL.createObjectURL(files[0])
        } else {
            image.value = null
            company.image = (apiImage.value as string)
        }
    }

    const getSegments = async () => {
        const res = await Api.get(`admin/trip-segments`)
        if (res.status == 200) {
            segments.value = res.data.segments
        } else {
            console.log(res)
            ElMessage.error(res.data.message)
        }
    }

    const getRoutes = async () => {
        const res = await Api.get(`admin/routes`)
        if (res.status == 200) {
            routes.value = res.data.routes
        } else {
            console.log(res)
            ElMessage.error(res.data.message)
        }
    }

    const getCompany = async (id: number | string) => {
        const res = await Api.get(`admin/travel-companies/${id}`)

        if (res.status == 200) {
            const data = res.data.company
    
            company.id = data.id
            company.area = data.area
            company.user = data.user
            company.name = data.name
            company.phone = data.phone
            company.description = data.description
            company.created_at = data.created_at
            company.segments = data.trip_segments
            cars.value = data.cars

            apiImage.value = getImageUrl(data.image)
            company.image = apiImage.value
            console.log(data)
        } else {
            console.log(res)
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (company.area) {
            company.area.lat = lat
            company.area.long = lng
        } else {
            company.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(company.area);
    }

    const update = () => {
        loading.value = true
        getCompany(id as string).finally(() => {
            loading.value = false
            showModal1.value = false
            showModal2.value = false
        })
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (company.area) {
                company.area.lat = position.coords.latitude
                company.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!company.area?.lat || !company.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(company)
                if (image.value) {
                    formData.append("image", image.value)
                } else {
                    formData.delete("image")
                }
                if (!company.phone || (company.phone as string).length < 1) {
                    formData.delete('phone')
                }
                if (!company.password || (company.password as string).length < 1) {
                    formData.delete('password')
                }
                const res = await Api.post('/admin/travel-companies/' + company.id, company, formData)
                if (res.status == 200) {
                    ElMessage.success({message: 'Atualizado com sucesso'})
                    await getCompany(id as string)
                } else {
                    console.log(res)
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getCompany(id as string),
            getSegments(),
            getRoutes()
        ])
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "col-12",
      header: company.id ? company.name:'Procurando Empresa'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 12
        }, {
          default: _withCtx(() => [
            company
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  disabled: saving.value,
                  model: company,
                  "label-position": "top",
                  rules: rules.value,
                  ref_key: "formRef",
                  ref: formRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElRow), { gutter: 30 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElCol), {
                          sm: 24,
                          md: 12,
                          lg: 10
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElFormItem), {
                              label: "Nome da empresa",
                              prop: "name"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  name: "name",
                                  modelValue: company.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((company.name) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Numero de telfone",
                              prop: "number"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  name: "number",
                                  modelValue: company.phone,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.phone) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Senha da empresa",
                              prop: "password"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  name: "password",
                                  modelValue: company.password,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((company.password) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), {
                              label: "Descricao da empresa",
                              prop: "description"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  type: "textarea",
                                  name: "description",
                                  modelValue: company.description,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((company.description) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElFormItem), { label: "Cadastrado" }, {
                              default: _withCtx(() => [
                                _cache[13] || (_cache[13] = _createTextVNode(" Por ", -1)),
                                _createElementVNode("b", null, _toDisplayString(company.user?.name), 1),
                                _cache[14] || (_cache[14] = _createTextVNode(", em ", -1)),
                                _createElementVNode("b", null, _toDisplayString(company.created_at ? new Date(company.created_at).toLocaleString():'-'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ElCol), {
                          sm: 24,
                          md: 12,
                          lg: 14
                        }, {
                          default: _withCtx(() => [
                            (company.area)
                              ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                                  key: 0,
                                  label: "Local",
                                  prop: "area.name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      name: "area",
                                      modelValue: company.area.name,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((company.area.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_unref(ElButton), {
                                plain: "",
                                class: "position-absolute end-0",
                                style: {"z-index":"1024"},
                                loading: locating.value || loading.value,
                                size: "large",
                                type: "success",
                                onClick: _withModifiers(locate, ["prevent"])
                              }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode(" Localizar-me ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["loading"]),
                              (company.area)
                                ? (_openBlock(), _createBlock(_unref(LMap), {
                                    key: 0,
                                    onContextmenu: onMapClick,
                                    ref: "map",
                                    zoom: 16,
                                    center: [company.area.lat, company.area.long]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(LTileLayer), {
                                        url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                                        "layer-type": "base",
                                        name: "OpenStreetMap"
                                      }),
                                      (company.area)
                                        ? (_openBlock(), _createBlock(_unref(LMarker), {
                                            key: 0,
                                            "lat-lng": [company.area.lat, company.area.long]
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(LTooltip), null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(company.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["lat-lng"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["center"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(ElFormItem), {
                              label: "Logotipo",
                              prop: "image"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  style: {"max-height":"250px","max-width":"100%"},
                                  src: (company.image as string)
                                }, null, 8, _hoisted_3),
                                _createElementVNode("input", {
                                  type: "file",
                                  name: "image",
                                  onChange: changeFile
                                }, null, 32)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "model", "rules"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElRow), {
              justify: "space-between",
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElCol), { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (submit(formRef.value))),
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" Salvar alterações ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElCol), { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      type: "warning",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showTravels.value = true)),
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" Marcar Viagens ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElCol), {
                  sx: 24,
                  md: 12,
                  class: "p-4"
                }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Carros", -1)),
                    _createVNode(PersonalTable, {
                      loading: loading.value,
                      height: 450,
                      showRows: 10,
                      cols: [
                                {label: '#', prop: 'id'},
                                {label: 'Referencia', prop: 'reference'},
                                {label: 'Nome', prop: 'name'},
                                {label: 'Placa', prop: 'plate'},
                            ],
                      data: cars.value
                    }, null, 8, ["loading", "data"]),
                    _createVNode(_unref(ElButton), {
                      plain: "",
                      type: "primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (showModal1.value = true))
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" Adicionar Carro ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElCol), {
                  sx: 24,
                  md: 12,
                  class: "p-4"
                }, {
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Preços", -1)),
                    _createVNode(PersonalTable, {
                      loading: loading.value,
                      height: 450,
                      showRows: 10,
                      cols: [
                                {label: '#', prop: 'id'},
                            ],
                      data: company.segments
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "Trecho",
                          "class-name": "auto",
                          "min-width": 150
                        }, {
                          default: _withCtx((data) => [
                            _createTextVNode(_toDisplayString(data.row.from.name) + " - " + _toDisplayString(data.row.to.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Preço",
                          "class-name": "auto",
                          "min-width": 150
                        }, {
                          default: _withCtx((data) => [
                            _createTextVNode(_toDisplayString(data.row.pivot.price) + " MT ", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "data"]),
                    _createVNode(_unref(ElButton), {
                      plain: "",
                      type: "primary",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (showModal2.value = true))
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Definir preço ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["header"]),
    _createVNode(_unref(ElDialog), {
      modelValue: showModal1.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showModal1).value = $event)),
      title: 'Cadastrar carro'
    }, {
      default: _withCtx(() => [
        _createVNode(CreateCar, {
          onClose: update,
          travel_company_id: (company.id as number)
        }, null, 8, ["travel_company_id"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: showModal2.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showModal2).value = $event)),
      title: 'Definir preço de viagem'
    }, {
      default: _withCtx(() => [
        _createVNode(CreateTravelPrice, {
          onClose: update,
          travel_company_id: (company.id as number),
          segments: segments.value
        }, null, 8, ["travel_company_id", "segments"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: showTravels.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showTravels).value = $event)),
      title: 'Marcar viagens e publicar',
      class: "col-11 col-md-10 col-lg-5"
    }, {
      default: _withCtx(() => [
        _createVNode(CreateTravel, {
          onClose: _cache[11] || (_cache[11] = ($event: any) => (showTravels.value = false)),
          travel_company_id: (company.id as number),
          cars: cars.value,
          routes: routes.value
        }, null, 8, ["travel_company_id", "cars", "routes"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})